import { render, staticRenderFns } from "./DomainOppositionForm.vue?vue&type=template&id=6d20af44&"
import script from "./DomainOppositionForm.vue?vue&type=script&lang=js&"
export * from "./DomainOppositionForm.vue?vue&type=script&lang=js&"
import style0 from "./DomainOppositionForm.vue?vue&type=style&index=0&id=6d20af44&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports